/** Fixed control-API port (HTTP, signed bodies). */
export const CONTROL_PORT = 51821;
/** Fixed WireGuard listen port (UDP, TCP auto). */
export const WG_PORT = 51820;
/** Default proof-of-work difficulty in leading zero bits. */
export const POW_BITS = 20;
/** Memo prefix that tags a CumulusVPN premium payment. */
export const MEMO_PREFIX = 'CVPN1:';
//# sourceMappingURL=types.js.map